module.exports = __webpack_public_path__ + "img/donatella-araujo.9ecb62c0.png";